// Module
var code = "<coveo-analytics access-token=\"{{$ctrl.accessToken}}\" organization-id=\"{{$ctrl.organizationId}}\" coveo-user-analytics-url=\"{{$ctrl.coveoUserAnalyticsUrl}}\" authorized-user-email=\"{{$ctrl.authorizedUserEmail}}\"></coveo-analytics> ";
// Exports
module.exports = code;